module.exports = __webpack_public_path__ + "img/index-ico6.5eba2b52.png";